import { render, staticRenderFns } from "./footerSouthern.vue?vue&type=template&id=73bd70e1&scoped=true"
import script from "./footerSouthern.vue?vue&type=script&lang=js"
export * from "./footerSouthern.vue?vue&type=script&lang=js"
import style0 from "./footerSouthern.vue?vue&type=style&index=0&id=73bd70e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd70e1",
  null
  
)

export default component.exports